import { LinkedVisit, Patient, S1JobSyncStatus } from '@doc-abode/data-models';

/**
 * Utility which checks wether a job has linked jobs for a given HCP
 * @param job the job for which to interrogage the sync status
 * @param linkedVisits array of S1 jobs to check against
 * @param isBuddy indicator whether to check for the primary or secondary HCP
 * @returns boolean; true if a job has matching S1 jobs; false otherwise
 */
function hasLinkedVisits(job: Patient, linkedVisits: LinkedVisit[], isBuddy: boolean): boolean {
    const personJobId = isBuddy ? '1' : '0';

    return linkedVisits.some(
        (linkedVisit) => linkedVisit.jobId === job.id && linkedVisit.personJobId === personJobId,
    );
}

/**
 * Utility to return the S1 sync status of a job
 * @param job the job for which to interrogage the sync status
 * @param isLoading indicator whether a load event is in progress
 * @param linkedVisits array of S1 jobs to check against
 * @param isBuddy indicator whether to check for the primary or secondary HCP
 * @returns S1JobSyncStatus
 */
export function getJobS1SyncStatus(
    job: Patient,
    isLoading: boolean,
    linkedVisits: LinkedVisit[],
    isBuddy: boolean,
): S1JobSyncStatus {
    // Deals with an invalid request for buddy information when dealing with a single assignee job
    if (isBuddy && job.staffRequired !== 2) {
        return S1JobSyncStatus.DO_NOT_SYNC;
    }

    if (isLoading) {
        return S1JobSyncStatus.LOADING;
    }

    return hasLinkedVisits(job, linkedVisits, isBuddy)
        ? S1JobSyncStatus.SYNCED
        : S1JobSyncStatus.NOT_SYNCED;
}
